import { FC } from "react";
import useEdit, { ReceivedProps } from "./hook";
import { Styles } from "./styled";
import EditPage from "@lhd/components/CloneApp/pages/EditPage";
import ModalConfirm from "@lhd/components/Modal/ModalConfirm";

const EditLayout = (props: ReturnType<typeof useEdit>) => {
  return (
    <Styles>
      <EditPage hasControlPageMode {...props} />
      <ModalConfirm
        isSubmitting={props.isLoadingChangeStatus}
        isOpen={props.openModalChangeStatus}
        content={props.modalContent}
        onCancel={() => props.setOpenModalChangeStatus(false)}
        onOk={props.onOkModalChangeStatus}
      />
    </Styles>
  );
};

const Edit: FC<ReceivedProps> = (props) => <EditLayout {...useEdit(props)} />;

export default Edit;
